import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { joinStreetHouseNumber, joinZipCodeCity } from '../../../../../utils/address';
import { Address } from '../../../../../utils/checkoutState';
import { getAssetUrl } from '../../../../../utils/config';
import './style.scss';

type DropdownProps = {
  lastUsedAddress?: Address;
  onMyLocation: () => void;
  onLastUsedAddress: () => void;
  isDisabled?: boolean;
};

const Dropdown = ({ lastUsedAddress, onMyLocation, onLastUsedAddress, isDisabled }: DropdownProps) => (
  <div className="collection-point-dropdown">
    <div
      className={classNames('collection-point-dropdown__item', { 'cursor-disabled': isDisabled })}
      onClick={() => !isDisabled && onMyLocation()}
    >
      <div className="collection-point-dropdown__left">
        <img className="collection-point-dropdown__icon" src={getAssetUrl('collectionPoints/location.svg')} />
      </div>
      <div className="collection-point-dropdown__right">
        <div className="collection-point-dropdown__main">
          <FormattedMessage id="shipping.collectionPoint.search.myLocation" />
        </div>
        <div className="collection-point-dropdown__sub"></div>
      </div>
    </div>
    {lastUsedAddress && (
      <>
        <div className="collection-point-dropdown__headline">
          <FormattedMessage id="shipping.collectionPoint.search.lastUsedAddress" />
        </div>
        <div
          className={classNames('collection-point-dropdown__item', { 'cursor-disabled': isDisabled })}
          onClick={() => !isDisabled && onLastUsedAddress()}
        >
          <div className="collection-point-dropdown__left">
            <img className="collection-point-dropdown__icon" src={getAssetUrl('collectionPoints/clock.svg')} />
          </div>
          <div className="collection-point-dropdown__right">
            <div className="collection-point-dropdown__main">{joinStreetHouseNumber(lastUsedAddress)}</div>
            <div className="collection-point-dropdown__sub">{joinZipCodeCity(lastUsedAddress)}</div>
          </div>
        </div>
      </>
    )}
  </div>
);

export default Dropdown;
